
const fn = async () => {
  return 'deleteFn'
}

export default fn
